import { Injectable } from '@angular/core';
import { HttpBaseService } from '../httpBase/httpBase.service';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../Interfaces/apiResponse.interface';
import {
  PoRFPInsights,
  PoRFPListResponse,
  PoRFPDetailsResponse,
} from '../../models/po-rfp';
import {
  ENDPOINTS_BUYER,
  ENDPOINTS_CONTRACTOR,
} from '../../constants/ENDPOINTS';
import { PaymentResponse } from '../../models/payment';

@Injectable({
  providedIn: 'root',
})
export class PoRFPService extends HttpBaseService {
  getBuyerPoRFPInsights(): Observable<ApiResponse<PoRFPInsights>> {
    const url = `${ENDPOINTS_BUYER.PURCHASE_ORDERS_RFP.GET_PO_INSIGHTS}`;
    return this.get(url);
  }

  getBuyerPoRFPList(
    page = 1,
    items_per_page = 25,
    state?: 'active' | 'inActive'
  ): Observable<PoRFPListResponse> {
    const url = `${ENDPOINTS_BUYER.PURCHASE_ORDERS_RFP.GET_PO_LIST}?page=${page}&items_per_page=${items_per_page}${state ? '&state=' + state : ''}`;
    return this.get(url);
  }

  getBuyerPoRFPDetails(poId: number): Observable<PoRFPDetailsResponse> {
    const url = `${ENDPOINTS_BUYER.PURCHASE_ORDERS_RFP.GET_PO_DETAILS.replace('{poId}', poId.toString())}`;
    return this.get(url);
  }

  confirmBuyerPoRFPPayment(
    paymentId: number,
    paymentDocumentId: string
  ): Observable<PaymentResponse> {
    const url = `${ENDPOINTS_BUYER.PURCHASE_ORDERS_RFP.POST_CONFIRM_PAYMENT.replace('{paymentId}', paymentId.toString())}`;
    return this.post(url, { payment_document: Number(paymentDocumentId) });
  }

  confirmBuyerPoRFP(poId: number) {
    const url = `${ENDPOINTS_BUYER.PURCHASE_ORDERS_RFP.POST_CONFIRM_PO_RFP.replace('{poId}', poId.toString())}`;
    return this.post(url, {}, { observe: 'response' });
  }

  /* Contractor */
  getContractorPoRFPInsights(): Observable<ApiResponse<PoRFPInsights>> {
    const url = `${ENDPOINTS_CONTRACTOR.PURCHASE_ORDERS.GET_PO_INSIGHTS}`;
    return this.get(url);
  }

  getContractorPoRFPList(
    page = 1,
    items_per_page = 25,
    state?: 'active' | 'inActive'
  ): Observable<PoRFPListResponse> {
    const url = `${ENDPOINTS_CONTRACTOR.PURCHASE_ORDERS.GET_PO_LIST}?page=${page}&items_per_page=${items_per_page}${state ? '&state=' + state : ''}`;
    return this.get(url);
  }

  getContractorPoRFPDetails(poId: number): Observable<PoRFPDetailsResponse> {
    const url = `${ENDPOINTS_CONTRACTOR.PURCHASE_ORDERS.GET_PO_DETAILS.replace('{poId}', poId.toString())}`;
    return this.get(url);
  }

  addSupportTicket(
    poId: number,
    data: {
      title: string;
      description: string;
      attachment?: number[];
    }
  ): Observable<{
    message: string;
    ticket_reference?: string;
    errors?: unknown;
  }> {
    const url =
      ENDPOINTS_CONTRACTOR.PURCHASE_ORDERS.POST_SUPPORT_TICKET.replace(
        '{poId}',
        poId?.toString()
      );
    return this.post(url, data);
  }
}
